// Curated brand image library — cohesive dark luxury art direction.
export const IMAGES = {
  heroSkyline:
    "https://static.prod-images.emergentagent.com/jobs/ac59dcc1-971d-4057-9b36-54751a226e67/images/cc63d555ef8aa15624d995e21246bb3db8081ee389c275adda03cda63457fce7.jpeg",
  conference:
    "https://static.prod-images.emergentagent.com/jobs/ac59dcc1-971d-4057-9b36-54751a226e67/images/e6d4eb47793ad2a847e6c277336657078a5803eebfdcf22f6e4e93966e28990f.jpeg",
  marbleInterior:
    "https://static.prod-images.emergentagent.com/jobs/ac59dcc1-971d-4057-9b36-54751a226e67/images/f6bfbc5cce715efa98e7fea3301ec6d74b17553066ab84c137d664c256d1e2fe.jpeg",
  comingSoon:
    "https://static.prod-images.emergentagent.com/jobs/ac59dcc1-971d-4057-9b36-54751a226e67/images/f59ac92e842bd8398faca402848c534f98161f58b886b32370d4fd8c5562fe23.jpeg",
  residential:
    "https://images.pexels.com/photos/31737859/pexels-photo-31737859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  commercialLobby:
    "https://images.unsplash.com/photo-1758448656990-398443036eb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBvZmZpY2UlMjBtYXJibGV8ZW58MHx8fHwxNzg1NTMxODk0fDA&ixlib=rb-4.1.0&q=85",
  builders:
    "https://images.pexels.com/photos/31737860/pexels-photo-31737860.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  skyscraperDusk:
    "https://images.unsplash.com/photo-1541447271487-09612b3f49f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMHNreXNjcmFwZXIlMjBkdXNrJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NTUzMjA2OXww&ixlib=rb-4.1.0&q=85",
  penthouse:
    "https://images.unsplash.com/photo-1622989428689-569c4fe81c11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwZW50aG91c2UlMjBpbnRlcmlvciUyMG5pZ2h0JTIwY2l0eSUyMHZpZXd8ZW58MHx8fHwxNzg1NTMyMDY5fDA&ixlib=rb-4.1.0&q=85",
  yaleOffice:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_elevated-escrow-tx/artifacts/6gptwclj_Yale%20St.png",
  heightsOffice:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_elevated-escrow-tx/artifacts/v41d0ut2_Heights%20Blvd.png",
};
